import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';
import Reveal from '../../components/Reveal';
import usePageTitle from '../../hooks/usePageTitle';
import { useAuth } from '../../context/AuthContext';
import { JobMeta } from './Jobs';
import NotFound from './NotFound';

export default function JobDetail() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { user } = useAuth();
  const [job, setJob] = useState(null);
  const [missing, setMissing] = useState(false);

  usePageTitle(job ? job.title : t('jobDetail.defaultTitle'));

  useEffect(() => {
    setJob(null);
    setMissing(false);
    api.get(`/api/site/jobs/${id}`).then(({ job: j }) => setJob(j)).catch(() => setMissing(true));
  }, [id]);

  if (missing) return <NotFound />;
  if (!job) {
    return (
      <section className="band"><div className="shell"><p className="muted">{t('jobDetail.loading')}</p></div></section>
    );
  }

  // A signed-in nanny goes straight to their application; everyone else registers first.
  const applyTo = user?.role === 'nanny' ? '/nanny/application' : '/register/nanny';

  return (
    <>
      <section className="page-hero">
        <div className="shell">
          <Reveal>
            <Link className="back-link" to="/jobs">{t('jobDetail.allJobs')}</Link>
            <h1>{job.title}</h1>
            <JobMeta job={job} />
            <div className="hero-actions">
              <Link className="btn btn-primary btn-lg" to={applyTo}>
                {user?.role === 'nanny' ? t('jobDetail.goToApplication') : t('jobDetail.applyNow')}
              </Link>
              <Link className="btn btn-outline btn-lg" to="/contact">{t('jobDetail.askQuestion')}</Link>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <Reveal className="job-body">
            <h2>{t('jobDetail.aboutJob')}</h2>
            <p className="prose">{job.description}</p>
            {job.requirements && (
              <>
                <h2>{t('jobDetail.whatWereLookingFor')}</h2>
                <p className="prose">{job.requirements}</p>
              </>
            )}
            <p className="muted">{t('jobDetail.applyNote')}</p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
